import React from 'react';
import { PackageHeldByList, PackageVisibility } from '@/types/package';
import { campaignLine } from '../packageDisplay';

interface CampaignLineProps {
  heldBy: PackageHeldByList;
  visibility: PackageVisibility;
  className?: string;
}

/**
 * One line under the list's Khusus chip. Truncated by CSS only, so a screen
 * reader still reads the whole name; dates and status sit in the hover title
 * and on the package page.
 */
export const CampaignLine: React.FC<CampaignLineProps> = ({
  heldBy,
  visibility,
  className = '',
}) => {
  const line = campaignLine(heldBy, visibility);
  if (!line) return null;

  return (
    <div
      className={`mt-1 flex max-w-[220px] items-center gap-1 text-[12px] leading-4 text-gray-500 ${className}`}
      title={line.title}
    >
      {line.kind === 'holders' && (
        <i
          className="ri-megaphone-line flex-shrink-0 text-[12px]"
          aria-hidden="true"
        />
      )}
      <span
        className={`truncate ${
          line.kind === 'unknown'
            ? 'cursor-help underline decoration-dotted'
            : ''
        }`}
      >
        {line.text}
      </span>
      {line.more > 0 && (
        <>
          <span
            className="flex-shrink-0 rounded-full bg-gray-100 px-1.5 text-[11px] text-gray-600"
            aria-hidden="true"
          >
            +{line.more}
          </span>
          <span className="sr-only">dan {line.more} campaign lain</span>
        </>
      )}
    </div>
  );
};

export default CampaignLine;
